import tripadvisorMetaMetrics from "models/metrics/metasearchMetrics/tripadvisor-meta/tripadvisorMetaMetrics";
import googleHotelAdsMetrics from "models/metrics/metasearchMetrics/google-hotel-ads/googleHotelAdsMetrics";
import skyscannerMetrics from "models/metrics/metasearchMetrics/skyscanner/skyscannerMetrics";
import trivagoMetaMetrics from "models/metrics/metasearchMetrics/trivago-meta/trivagoMetaMetrics";
import kayakMetrics from "models/metrics/metasearchMetrics/kayak/kayakMetrics";
import wegoMetrics from "models/metrics/metasearchMetrics/wego/wegoMetrics";
import bingHotelAdsMetrics from "models/metrics/metasearchMetrics/bing-hotel-ads/bingHotelAdsMetrics";
import trivagoSLMetrics from "models/metrics/metasearchMetrics/trivago-sl/trivagoSLMetrics";
import googleHotelAdsPPAMetrics from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/googleHotelAdsPPAMetrics";
import googleHotelAdsMetricsFbl from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/googleHotelAdsMetricsFbl";
import tripadvisorSpMetrics from "./metasearchMetrics/tripadvisor-sp/tripadvisorSpMetrics";

const allMetrics = [
    ...tripadvisorMetaMetrics,
    ...tripadvisorSpMetrics,
    ...googleHotelAdsMetrics,
    ...googleHotelAdsMetricsFbl,
    ...skyscannerMetrics,
    ...trivagoMetaMetrics,
    ...kayakMetrics,
    ...wegoMetrics,
    ...bingHotelAdsMetrics,
    ...trivagoSLMetrics,
    ...googleHotelAdsPPAMetrics,
];

export function findMetricById(metricId) {
    return allMetrics.find((metricClass) => metricClass.field === metricId);
}

export default allMetrics;
